/* 2026-10-21 top-tier pass: the sticky Add to cart bar follows the main Add to cart button.
   It shows only once that button has scrolled above the viewport and hides again when the
   button is back in view (or below it), near the page bottom, and after jumps, back-to-top
   or scroll restore, because the state is recalculated from the button's position on every
   scroll, resize, load, pageshow and hash change instead of from intersection events. */
if (!customElements.get('sticky-atc-panel')) {
  // 2026-10-29 round 2: the bar steps aside while any of these is under it: other products' buy buttons,
  // this product's own purchase options (variants, subscription), the reviews slider and the footer.
  const STICKY_ATC_STOP_ZONES = [
    '.av-addons', '.cc-product-recommendations', 'product-recommendations',
    'form.js-product-form-main', 'variant-picker', '.shopify_subscriptions_app_container',
    '.jdgm-widget', '.jdgm-carousel-wrapper', '[id$="__avon-reviews-top"]', '.shopify-section-group-footer-group', '[data-av-sticky-stop]'
  ].join(', ');

  class StickyAtcPanel extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('.cc-main-product') || document;
      this.onChange = this.onChange.bind(this);
      this.events = ['scroll', 'resize', 'orientationchange', 'load', 'pageshow', 'hashchange', 'popstate'];
      this.events.forEach((name) => window.addEventListener(name, this.onChange, { passive: true }));
      this.update();
    }

    disconnectedCallback() {
      this.events.forEach((name) => window.removeEventListener(name, this.onChange));
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    mainButton() {
      if (!this.button || !this.button.isConnected) {
        this.button = this.productSection.querySelector('form.js-product-form-main button[name="add"]')
          || this.productSection.querySelector('form.js-product-form-main');
      }
      return this.button;
    }

    onChange() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    coversOtherProducts() {
      const band = window.innerHeight - 120;
      return Array.from(document.querySelectorAll(STICKY_ATC_STOP_ZONES)).some((zone) => {
        const r = zone.getBoundingClientRect();
        return r.height > 0 && r.top < window.innerHeight && r.bottom > band;
      });
    }

    update() {
      const button = this.mainButton();
      const rect = button ? button.getBoundingClientRect() : null;
      // 2026-10-27 F-35: on phones the bar also shows while the main button is still below the screen.
      const phone = window.matchMedia('(max-width: 749px)').matches;
      // 2026-10-29 polish: on phones, only after the shopper has started scrolling, so the price is never covered on load.
      const pastButton = !!rect && rect.height > 0 && (rect.bottom < 0 || (phone && window.scrollY > 160 && rect.top > window.innerHeight));
      const nearBottom = window.scrollY + window.innerHeight + 100 > document.documentElement.scrollHeight;
      const show = pastButton && !nearBottom && !this.coversOtherProducts();
      document.body.classList.toggle('scrolled-to-bottom', nearBottom);
      this.classList.toggle('sticky-atc-panel--out', !show);
      this.toggleAttribute('inert', !show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
